import { store } from '@atredux/store'
import { _navigateToTool } from '@src/components/SideBar/utils/SideBarUtil'
import { getToolById } from '@src/crossFrame/apis/ToolRegistration'
import { getSelectedTool } from '@src/redux/selectors/toolSelector'
import { getToolDetailsById } from '@services/ToolMenuConfigService'
import { ITool } from '@atredux/slices/toolSlice'
import _ from 'lodash'

export async function setCurrentToolListener (message: any) {
    console.debug('Received request to set current tool.', JSON.stringify(message))

    if (message && message.data && typeof message.data?.toolId === 'string') {
        const toolId = message.data.toolId
        let tool: ITool = getToolDetailsById(toolId)

        if (!tool) {
            console.debug(`Checking if tool ${toolId} is in registry but not in menu config`)
            tool = getToolById(toolId)
            if (!tool) {
                return Promise.reject(`Tool '${toolId}' not found in registry.`)
            }
        }

        // Temporary workaround Sep 2025
        if (toolId === 'tmoe_tasks_tool_redirect') {
            console.debug('Forcing Task List Redirect tool')
            tool = getToolById(toolId)
        }

        let params = message.data.toolParameters
        const hashPath = message.data.hashPath

        if (params && typeof params !== 'object') {
            return Promise.reject(`Invalid request parameters, the 'toolParameters' field must be a valid object when defined.`)
        }

        if (getSelectedTool(store.getState()).toolName === toolId) {
            params = params || {}

            params._dc = (new Date()).getTime()
        }

        // TS gives TypeError if we reassign to tool fetched from redux state
        const toolToNavigate: ITool = _.cloneDeep(tool)

        toolToNavigate.toolParameters = params
        toolToNavigate.hashPath = hashPath

        _navigateToTool(toolToNavigate)

        return Promise.resolve(toolId)
    } else {
        return Promise.reject(`Invalid request parameters, the 'toolId' field is mandatory`)
    }
}
